import get from "lodash/get";

import { useAuth } from "@/contexts/auth/useAuth";

import type { Status } from "@/schemas";

function useColumnFilters() {
  const { currentAccount } = useAuth();

  function shouldFilter(status: Status) {
    const shows = {
      reblog: status.reblog !== null,
      reply: status.in_reply_to_id !== null,
    };

    if (!currentAccount?.settings?.home?.shows) {
      return false; // Default to no filtering if settings are unavailable
    }

    return (Object.keys(shows) as (keyof typeof shows)[]).some((key) => {
      const value = shows[key];

      return (
        get(currentAccount, ["settings", "home", "shows", key], true) ===
          false && value
      );
    });
  }

  return {
    shouldFilter,
  };
}

export { useColumnFilters };
